import { render, staticRenderFns } from "./StudentHomeNew.vue?vue&type=template&id=06110f89&scoped=true&"
import script from "./StudentHomeNew.vue?vue&type=script&lang=js&"
export * from "./StudentHomeNew.vue?vue&type=script&lang=js&"
import style0 from "./StudentHomeNew.vue?vue&type=style&index=0&id=06110f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06110f89",
  null
  
)

export default component.exports